import React from 'react';

import Loader from '../UI/loader';

import './section.scss';

interface ISectionProps {
  className?: string;
  title: string;
  isLoading?: boolean;
  children: React.ReactNode;
}

const Section: React.FC<ISectionProps> = ({ className = '', title, children, isLoading }) => {
  return (
    <section className={`section ${className}`}>
      <h2 className="section-title">{title}</h2>
      {children}

      {isLoading && <Loader />}
    </section>
  );
};

export default Section;
